import React, { useState } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import MonthlyPaymentModal from "widgets/shared/montly-payment-modal";
import { ConfigurationPricingTotalFooter } from "./ConfigurationPricingTotalFooter";
import { ZakelijkPriceDetails } from "./ZakelijkPriceDetails";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";

export interface DoorOptionsFooterProps {
  selectedDoor: OptionTemplate | null;
  isMonthlyPaymentAvailable: boolean;
  monthlyPayment?: number;
  addToCart: () => void;
}

export const DoorOptionsFooterMobile: React.FC<DoorOptionsFooterProps> = ({
  selectedDoor,
  monthlyPayment,
  addToCart,
}) => {
  const [isMonthlyPaymentModalOpened, setIsMonthlyPaymentModalOpened] =
    useState(false);

  if (!selectedDoor) return null;

  const productPrice = "€" + (selectedDoor?.price ?? 0).toFixed(2);
  const isProfielProduct = zakelijkProfielCodes.includes(
    selectedDoor?.code ?? "",
  );
  return (
    <>
      <MonthlyPaymentModal
        isOpen={isMonthlyPaymentModalOpened}
        setIsOpen={setIsMonthlyPaymentModalOpened}
      />
      <div className="gg-grid gg-min-h-[8.5rem] gg-w-full gg-border-t-2 gg-border-gray-200 gg-bg-gray-50 gg-shadow-inner">
        <div className="gg-flex gg-w-full gg-items-center gg-justify-between gg-gap-x-4 gg-px-2.5 gg-py-4 gg-pl-4 sm:gg-pl-8">
          <div className="gg-flex gg-gap-x-4 sm:gg-gap-x-8">
            <div className="gg-mt-2 gg-flex gg-flex-col gg-items-center sm:gg-mt-0">
              {/* Selected door name */}
              <div className="gg-max-w-[100px]">
                <h1 className="gg-grid gg-h-full gg-items-center gg-justify-center gg-self-center gg-text-center gg-text-[15px] gg-font-bold gg-text-slate-800 sm:gg-text-lg">
                  {selectedDoor.name}
                </h1>
                {!isProfielProduct && (
                  <p className="gg-mt-0.5 gg-text-base gg-text-purple-300">
                    {productPrice}
                  </p>
                )}
              </div>
            </div>
            {/* Product details */}
            <ZakelijkPriceDetails selectedDoorCode={selectedDoor?.code} />
          </div>

          <ConfigurationPricingTotalFooter selectedDoor={selectedDoor} />
        </div>
        <div className="gg-flex gg-min-h-min gg-justify-end gg-border-t gg-border-gray-200 gg-pl-2 sm:gg-pl-8">
          {/* Buttons  */}
          <div className="gg-flex gg-gap-0 gg-text-sm gg-leading-6">
            <button
              type="button"
              onClick={() => addToCart()}
              data-testid="add-to-cart-mobile"
              className="gg-justify-center gg-rounded-sm gg-bg-yellow-300 gg-px-4 gg-py-5 gg-font-bold gg-text-dark-blue hover:gg-bg-yellow-400 hover:gg-text-zinc-900 sm:gg-px-8 md:gg-px-12"
            >
              In winkelmand
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
